export { default } from "./ReadAloudGraphic";
